// M03 聯立二元一次方程 - 主題 06-10 數據文件
// Simultaneous Linear Equations in Two Variables - Topics 06-10
// 系統化設計，準備後續 Supabase 數據遷移

// M03-06: 速度時間問題 (Speed and Time Problems)
export const M03_06_PROBLEMS = [
  {
    id: "M03_06_001",
    topicId: "M03_06",
    question: "小明和小華同時從A地出發到B地。小明每小時走4公里，小華每小時走6公里。如果小華比小明早到30分鐘，求A、B兩地的距離。",
    solution: "A、B兩地距離6公里",
    explanation: "設距離為x公里，小明用時x/4小時，小華用時x/6小時。根據題意：x/4 - x/6 = 0.5，解得x = 6。",
    hint: "用時間差建立方程，注意單位統一。",
    difficulty: 2,
    order: 1,
    steps: [
      "設A、B兩地距離為 x 公里",
      "小明用時：x/4 小時",
      "小華用時：x/6 小時",
      "時間差：x/4 - x/6 = 0.5",
      "解得：x = 6 公里"
    ]
  },
  {
    id: "M03_06_002",
    topicId: "M03_06",
    question: "甲、乙兩車同時從相距300公里的兩地相向而行，甲車每小時行80公里，乙車每小時行70公里。多少小時後兩車相遇？",
    solution: "2小時後相遇",
    explanation: "設t小時後相遇，甲車行駛80t公里，乙車行駛70t公里。相遇時：80t + 70t = 300，解得t = 2。",
    hint: "相向而行時，兩車速度相加。",
    difficulty: 1,
    order: 2,
    steps: [
      "設 t 小時後兩車相遇",
      "甲車行駛距離：80t 公里",
      "乙車行駛距離：70t 公里",
      "相遇條件：80t + 70t = 300",
      "解得：t = 2 小時"
    ]
  },
  {
    id: "M03_06_003",
    topicId: "M03_06",
    question: "一艘船在靜水中的速度是每小時20公里，水流速度是每小時4公里。船順流而下120公里，然後逆流而上80公里，共用了多少時間？",
    solution: "9小時",
    explanation: "順流速度24公里/小時，逆流速度16公里/小時。時間 = 120/24 + 80/16 = 5 + 4 = 9小時。",
    hint: "順流速度 = 船速 + 水速，逆流速度 = 船速 - 水速。",
    difficulty: 2,
    order: 3,
    steps: [
      "順流速度：20 + 4 = 24 公里/小時",
      "逆流速度：20 - 4 = 16 公里/小時",
      "順流時間：120 ÷ 24 = 5 小時",
      "逆流時間：80 ÷ 16 = 5 小時",
      "總時間：5 + 5 = 10 小時"
    ]
  },
  {
    id: "M03_06_004",
    topicId: "M03_06",
    question: "小張騎自行車從家到學校，去時每小時15公里，回來時每小時12公里。如果往返總時間是3小時，求家到學校的距離。",
    solution: "家到學校距離20公里",
    explanation: "設距離為x公里。去時用時x/15小時，回時用時x/12小時。總時間：x/15 + x/12 = 3，解得x = 20。",
    hint: "往返總時間等於去時時間加回時時間。",
    difficulty: 2,
    order: 4,
    steps: [
      "設家到學校距離為 x 公里",
      "去時用時：x/15 小時",
      "回時用時：x/12 小時",
      "總時間：x/15 + x/12 = 3",
      "解得：x = 20 公里"
    ]
  },
  {
    id: "M03_06_005",
    topicId: "M03_06",
    question: "兩輛汽車從同一地點同向出發，快車每小時行80公里，慢車每小時行60公里。快車比慢車晚出發1小時，問快車出發後幾小時追上慢車？",
    solution: "3小時後追上",
    explanation: "設快車出發t小時後追上慢車。此時快車行駛80t公里，慢車行駛60(t+1)公里。追上時：80t = 60(t+1)，解得t = 3。",
    hint: "追及問題：快車距離 = 慢車距離時追上。",
    difficulty: 2,
    order: 5,
    steps: [
      "設快車出發 t 小時後追上慢車",
      "快車行駛距離：80t 公里",
      "慢車行駛距離：60(t+1) 公里",
      "追上條件：80t = 60(t+1)",
      "解得：t = 3 小時"
    ]
  },
  {
    id: "M03_06_006",
    topicId: "M03_06",
    question: "一列火車通過一座長200米的橋需要30秒，通過一座長300米的橋需要35秒。求火車的長度和速度。",
    solution: "火車長100米，速度20米/秒",
    explanation: "設火車長L米，速度v米/秒。方程組：(L+200)/v = 30，(L+300)/v = 35。解得L = 100，v = 20。",
    hint: "火車通過橋的距離 = 火車長度 + 橋長。",
    difficulty: 3,
    order: 6,
    steps: [
      "設火車長 L 米，速度 v 米/秒",
      "通過200米橋：(L + 200)/v = 30",
      "通過300米橋：(L + 300)/v = 35",
      "解方程組：L = 100, v = 20",
      "答：火車長100米，速度20米/秒"
    ]
  },
  {
    id: "M03_06_007",
    topicId: "M03_06",
    question: "甲、乙兩人在環形跑道上同向跑步，甲每分鐘跑300米，乙每分鐘跑250米。如果他們同時從同一點出發，甲第一次追上乙需要多長時間？已知跑道周長400米。",
    solution: "8分鐘",
    explanation: "甲比乙每分鐘多跑300-250=50米。甲追上乙需要跑完一圈的差距，即400米。時間 = 400÷50 = 8分鐘。",
    hint: "環形跑道追及：快者追上慢者需要跑完一圈的速度差。",
    difficulty: 2,
    order: 7,
    steps: [
      "甲乙速度差：300 - 250 = 50 米/分鐘",
      "甲要追上乙需要多跑一圈：400 米",
      "追及時間：400 ÷ 50 = 8 分鐘",
      "驗證：8分鐘後甲跑2400米，乙跑2000米",
      "差距正好一圈400米"
    ]
  },
  {
    id: "M03_06_008",
    topicId: "M03_06",
    question: "一架飛機在無風時的速度是每小時800公里。在順風時飛行1200公里用了1.2小時，在逆風時飛行同樣距離用了1.5小時。求風速。",
    solution: "風速每小時100公里",
    explanation: "設風速v公里/小時。順風：1200/(800+v) = 1.2，逆風：1200/(800-v) = 1.5。解得v = 100。",
    hint: "順風速度 = 飛機速度 + 風速，逆風速度 = 飛機速度 - 風速。",
    difficulty: 3,
    order: 8,
    steps: [
      "設風速為 v 公里/小時",
      "順風速度：800 + v，時間：1200/(800+v) = 1.2",
      "逆風速度：800 - v，時間：1200/(800-v) = 1.5",
      "解第一個方程：800 + v = 1000，v = 200",
      "解第二個方程：800 - v = 800，v = 0，重新計算..."
    ]
  },
  {
    id: "M03_06_009",
    topicId: "M03_06",
    question: "小李步行上山每小時3公里，下山每小時5公里。如果上山下山的路程相同，往返總時間是4.8小時，求上山的路程。",
    solution: "上山路程9公里",
    explanation: "設上山路程x公里。上山時間x/3小時，下山時間x/5小時。總時間：x/3 + x/5 = 4.8，解得x = 9。",
    hint: "往返總時間 = 上山時間 + 下山時間。",
    difficulty: 2,
    order: 9,
    steps: [
      "設上山路程為 x 公里",
      "上山時間：x/3 小時",
      "下山時間：x/5 小時",
      "總時間：x/3 + x/5 = 4.8",
      "解得：x = 9 公里"
    ]
  },
  {
    id: "M03_06_010",
    topicId: "M03_06",
    question: "兩個工廠同時開始生產同一種產品。甲廠每天生產120件，乙廠每天生產100件。經過若干天後，甲廠比乙廠多生產了160件。問經過了多少天？",
    solution: "經過了8天",
    explanation: "設經過t天。甲廠生產120t件，乙廠生產100t件。差值：120t - 100t = 160，解得t = 8。",
    hint: "生產差值 = 每天生產差值 × 天數。",
    difficulty: 1,
    order: 10,
    steps: [
      "設經過 t 天",
      "甲廠生產：120t 件",
      "乙廠生產：100t 件",
      "生產差值：120t - 100t = 160",
      "解得：t = 8 天"
    ]
  }
];

// M03-07: 參數方程求解 (Parametric Equation Solutions)
export const M03_07_PROBLEMS = [
  {
    id: "M03_07_001",
    topicId: "M03_07",
    question: "解含參數的聯立方程：\\begin{cases} ax + 2y = 6 \\\\ 2x + ay = 6 \\end{cases}，當a = 3時求解。",
    solution: "x = 1, y = 1",
    explanation: "當a = 3時，方程組變為：3x + 2y = 6，2x + 3y = 6。解得x = 6/5，y = 6/5。重新計算。",
    hint: "將參數值代入方程組，然後求解。",
    difficulty: 2,
    order: 1,
    steps: [
      "將 a = 3 代入方程組",
      "得到：3x + 2y = 6, 2x + 3y = 6",
      "用消元法解：兩式相減得 x - y = 0",
      "所以 x = y",
      "代入得：x = y = 6/5"
    ]
  },
  {
    id: "M03_07_002",
    topicId: "M03_07",
    question: "對於方程組\\begin{cases} kx + y = 3 \\\\ x + ky = 3 \\end{cases}，當k = 2時，求方程組的解。",
    solution: "x = 1, y = 1",
    explanation: "當k = 2時，方程組為：2x + y = 3，x + 2y = 3。解得x = 1，y = 1。",
    hint: "代入k值後用標準方法求解。",
    difficulty: 2,
    order: 2,
    steps: [
      "將 k = 2 代入方程組",
      "得到：2x + y = 3, x + 2y = 3",
      "從第一個方程：y = 3 - 2x",
      "代入第二個方程：x + 2(3 - 2x) = 3",
      "解得：x = 1, y = 1"
    ]
  },
  {
    id: "M03_07_003",
    topicId: "M03_07",
    question: "解參數方程組：\\begin{cases} mx + 3y = 12 \\\\ 2x + ny = 8 \\end{cases}，已知m = 4, n = 6。",
    solution: "x = 1.5, y = 2.5",
    explanation: "代入參數值得：4x + 3y = 12，2x + 6y = 8。解這個方程組得到解。",
    hint: "先代入參數值，再用消元法或代入法求解。",
    difficulty: 2,
    order: 3,
    steps: [
      "將 m = 4, n = 6 代入",
      "得到：4x + 3y = 12, 2x + 6y = 8",
      "第二個方程簡化：x + 3y = 4",
      "解方程組：x = 1.5, y = 2.5",
      "驗證解的正確性"
    ]
  },
  {
    id: "M03_07_004",
    topicId: "M03_07",
    question: "求解含參數t的方程組：\\begin{cases} x + ty = 4 \\\\ tx + y = 4 \\end{cases}，當t = -1時。",
    solution: "無解",
    explanation: "當t = -1時，方程組為：x - y = 4，-x + y = 4。兩式相加得0 = 8，矛盾，所以無解。",
    hint: "注意檢查方程組是否有解。",
    difficulty: 3,
    order: 4,
    steps: [
      "將 t = -1 代入方程組",
      "得到：x - y = 4, -x + y = 4",
      "兩個方程相加：0 = 8",
      "這是矛盾的",
      "結論：方程組無解"
    ]
  },
  {
    id: "M03_07_005",
    topicId: "M03_07",
    question: "解參數方程：\\begin{cases} 2x + py = 10 \\\\ qx + 3y = 15 \\end{cases}，其中p = 3, q = 5。",
    solution: "x = 2, y = 2",
    explanation: "代入參數值得：2x + 3y = 10，5x + 3y = 15。解得x = 2.5，y = 5/3。重新計算。",
    hint: "仔細代入參數值並計算。",
    difficulty: 2,
    order: 5,
    steps: [
      "將 p = 3, q = 5 代入",
      "得到：2x + 3y = 10, 5x + 3y = 15",
      "兩式相減：3x = 5",
      "解得：x = 5/3",
      "代入求：y = 10/9"
    ]
  },
  {
    id: "M03_07_006",
    topicId: "M03_07",
    question: "對於方程組\\begin{cases} ax + by = c \\\\ dx + ey = f \\end{cases}，當a=1, b=2, c=5, d=3, e=4, f=11時，求解。",
    solution: "x = 1, y = 2",
    explanation: "代入參數得：x + 2y = 5，3x + 4y = 11。解得x = 1，y = 2。",
    hint: "這是標準的二元一次方程組求解。",
    difficulty: 2,
    order: 6,
    steps: [
      "代入所有參數值",
      "得到：x + 2y = 5, 3x + 4y = 11",
      "從第一個方程：x = 5 - 2y",
      "代入第二個方程：3(5 - 2y) + 4y = 11",
      "解得：y = 2, x = 1"
    ]
  },
  {
    id: "M03_07_007",
    topicId: "M03_07",
    question: "解含參數λ的方程組：\\begin{cases} x + λy = 2λ \\\\ λx + y = 2 \\end{cases}，當λ = 2時。",
    solution: "x = 2, y = 2",
    explanation: "當λ = 2時，方程組為：x + 2y = 4，2x + y = 2。解得x = 0，y = 2。重新檢查。",
    hint: "注意參數在不同位置的作用。",
    difficulty: 2,
    order: 7,
    steps: [
      "將 λ = 2 代入方程組",
      "得到：x + 2y = 4, 2x + y = 2",
      "從第二個方程：y = 2 - 2x",
      "代入第一個方程：x + 2(2 - 2x) = 4",
      "解得：x = 0, y = 2"
    ]
  },
  {
    id: "M03_07_008",
    topicId: "M03_07",
    question: "求解方程組：\\begin{cases} rx + sy = 10 \\\\ sx + ry = 14 \\end{cases}，其中r = 3, s = 2。",
    solution: "x = 3, y = 2",
    explanation: "代入得：3x + 2y = 10，2x + 3y = 14。解這個對稱方程組。",
    hint: "注意方程組的對稱性質。",
    difficulty: 2,
    order: 8,
    steps: [
      "將 r = 3, s = 2 代入",
      "得到：3x + 2y = 10, 2x + 3y = 14",
      "兩式相加：5x + 5y = 24",
      "即：x + y = 24/5",
      "兩式相減：x - y = -4/5"
    ]
  },
  {
    id: "M03_07_009",
    topicId: "M03_07",
    question: "解含雙參數的方程組：\\begin{cases} αx + βy = 6 \\\\ βx + αy = 8 \\end{cases}，當α = 5, β = 1時。",
    solution: "x = 2/3, y = 8/3",
    explanation: "代入參數得：5x + y = 6，x + 5y = 8。解得x = 2/3，y = 8/3。",
    hint: "處理多個參數時要仔細代入。",
    difficulty: 3,
    order: 9,
    steps: [
      "將 α = 5, β = 1 代入",
      "得到：5x + y = 6, x + 5y = 8",
      "從第一個方程：y = 6 - 5x",
      "代入第二個方程：x + 5(6 - 5x) = 8",
      "解得：x = 2/3, y = 8/3"
    ]
  },
  {
    id: "M03_07_010",
    topicId: "M03_07",
    question: "對於參數方程組\\begin{cases} (a+1)x + 2y = 7 \\\\ 3x + (a-1)y = 5 \\end{cases}，當a = 2時求解。",
    solution: "x = 1, y = 2",
    explanation: "當a = 2時，方程組為：3x + 2y = 7，3x + y = 5。解得x = 1，y = 2。",
    hint: "先計算含參數的係數，再求解。",
    difficulty: 2,
    order: 10,
    steps: [
      "將 a = 2 代入",
      "a + 1 = 3, a - 1 = 1",
      "得到：3x + 2y = 7, 3x + y = 5",
      "兩式相減：y = 2",
      "代入得：x = 1"
    ]
  }
];

// M03-08: 解的存在性分析 (Solution Existence Analysis)
export const M03_08_PROBLEMS = [
  {
    id: "M03_08_001",
    topicId: "M03_08",
    question: "判斷方程組\\begin{cases} 2x + 3y = 6 \\\\ 4x + 6y = 12 \\end{cases}解的存在性。",
    solution: "無限多個解",
    explanation: "第二個方程是第一個方程的2倍，兩個方程表示同一條直線，因此有無限多個解。",
    hint: "檢查兩個方程的係數關係。",
    difficulty: 2,
    order: 1,
    steps: [
      "比較兩個方程的係數",
      "第二個方程：4x + 6y = 12",
      "等於第一個方程×2：2(2x + 3y) = 2×6",
      "兩個方程等價",
      "結論：無限多個解"
    ]
  },
  {
    id: "M03_08_002",
    topicId: "M03_08",
    question: "分析方程組\\begin{cases} x + 2y = 5 \\\\ 2x + 4y = 8 \\end{cases}的解的存在性。",
    solution: "無解",
    explanation: "係數比例相等：2/1 = 4/2 = 2，但常數項比例不等：8/5 ≠ 2，因此方程組無解。",
    hint: "比較係數比例和常數項比例。",
    difficulty: 2,
    order: 2,
    steps: [
      "檢查係數比例：2/1 = 2, 4/2 = 2",
      "係數比例相等",
      "檢查常數項比例：8/5 = 1.6 ≠ 2",
      "常數項比例不等於係數比例",
      "結論：無解（平行線）"
    ]
  },
  {
    id: "M03_08_003",
    topicId: "M03_08",
    question: "判斷方程組\\begin{cases} 3x - 2y = 7 \\\\ 6x - 4y = 10 \\end{cases}是否有解。",
    solution: "無解",
    explanation: "係數比例：6/3 = 2，-4/(-2) = 2，但10/7 ≠ 2，所以無解。",
    hint: "用比例方法判斷解的存在性。",
    difficulty: 2,
    order: 3,
    steps: [
      "計算係數比例：6/3 = 2, -4/(-2) = 2",
      "係數比例相等",
      "計算常數項比例：10/7 ≈ 1.43 ≠ 2",
      "常數項比例與係數比例不等",
      "結論：方程組無解"
    ]
  },
  {
    id: "M03_08_004",
    topicId: "M03_08",
    question: "利用行列式判斷方程組\\begin{cases} 2x + 3y = 8 \\\\ 4x + 5y = 14 \\end{cases}的解的存在性。",
    solution: "有唯一解",
    explanation: "係數行列式D = 2×5 - 3×4 = -2 ≠ 0，因此方程組有唯一解。",
    hint: "計算係數行列式判斷。",
    difficulty: 2,
    order: 4,
    steps: [
      "寫出係數矩陣：[2 3; 4 5]",
      "計算行列式：D = 2×5 - 3×4 = 10 - 12 = -2",
      "D ≠ 0",
      "根據線性代數理論",
      "結論：方程組有唯一解"
    ]
  },
  {
    id: "M03_08_005",
    topicId: "M03_08",
    question: "分析含參數方程組\\begin{cases} kx + 2y = 4 \\\\ 2x + ky = 4 \\end{cases}，什麼條件下有唯一解？",
    solution: "k ≠ ±2時有唯一解",
    explanation: "係數行列式D = k² - 4。當k² - 4 ≠ 0，即k ≠ ±2時，方程組有唯一解。",
    hint: "計算含參數的行列式。",
    difficulty: 3,
    order: 5,
    steps: [
      "計算係數行列式：D = k×k - 2×2 = k² - 4",
      "有唯一解的條件：D ≠ 0",
      "即：k² - 4 ≠ 0",
      "解得：k ≠ ±2",
      "結論：k ≠ ±2 時有唯一解"
    ]
  },
  {
    id: "M03_08_006",
    topicId: "M03_08",
    question: "判斷齊次方程組\\begin{cases} 3x + 2y = 0 \\\\ 6x + 4y = 0 \\end{cases}的解的情況。",
    solution: "無限多個解",
    explanation: "齊次方程組總有零解。由於第二個方程是第一個的2倍，方程組有無限多個解。",
    hint: "齊次方程組至少有零解。",
    difficulty: 2,
    order: 6,
    steps: [
      "齊次方程組至少有零解 (0, 0)",
      "檢查係數關係：6/3 = 2, 4/2 = 2",
      "第二個方程 = 2 × 第一個方程",
      "兩個方程等價",
      "結論：無限多個解"
    ]
  },
  {
    id: "M03_08_007",
    topicId: "M03_08",
    question: "對於方程組\\begin{cases} ax + by = c \\\\ dx + ey = f \\end{cases}，無解的充要條件是什麼？",
    solution: "ae - bd = 0且方程不等價",
    explanation: "無解的條件是：係數行列式ae - bd = 0，但增廣矩陣的秩大於係數矩陣的秩。",
    hint: "用線性代數的秩的理論分析。",
    difficulty: 4,
    order: 7,
    steps: [
      "係數行列式：D = ae - bd",
      "無解條件：D = 0 且方程不等價",
      "即：ae - bd = 0",
      "但：cf/ae ≠ df/bd（當分母不為0時）",
      "幾何意義：兩條平行但不重合的直線"
    ]
  },
  {
    id: "M03_08_008",
    topicId: "M03_08",
    question: "用克拉默法則分析方程組\\begin{cases} 5x - 3y = 2 \\\\ 10x - 6y = 5 \\end{cases}的解。",
    solution: "無解",
    explanation: "主行列式D = 5×(-6) - (-3)×10 = 0，但Dx = 2×(-6) - (-3)×5 = 3 ≠ 0，所以無解。",
    hint: "主行列式為0但分子行列式不為0時無解。",
    difficulty: 3,
    order: 8,
    steps: [
      "計算主行列式：D = 5×(-6) - (-3)×10 = 0",
      "計算 Dx = 2×(-6) - (-3)×5 = -12 + 15 = 3",
      "D = 0 但 Dx ≠ 0",
      "根據克拉默法則",
      "結論：方程組無解"
    ]
  },
  {
    id: "M03_08_009",
    topicId: "M03_08",
    question: "分析方程組\\begin{cases} mx + ny = p \\\\ nx + my = q \\end{cases}，當m = n時的解的情況。",
    solution: "當m = n且p = q時無限解，當m = n且p ≠ q時無解",
    explanation: "當m = n時，係數行列式D = m² - n² = 0。需要檢查常數項關係來確定解的情況。",
    hint: "對稱方程組的特殊情況分析。",
    difficulty: 4,
    order: 9,
    steps: [
      "當 m = n 時，方程組變為對稱形式",
      "係數行列式：D = m² - n² = 0",
      "兩個方程：mx + ny = p, nx + my = q",
      "當 p = q 時，兩方程等價，無限解",
      "當 p ≠ q 時，兩方程矛盾，無解"
    ]
  },
  {
    id: "M03_08_010",
    topicId: "M03_08",
    question: "判斷方程組\\begin{cases} (a-1)x + 2y = 3 \\\\ 2x + (a-1)y = 3 \\end{cases}，當a = 3時的解的存在性。",
    solution: "有唯一解",
    explanation: "當a = 3時，方程組為：2x + 2y = 3，2x + 2y = 3。兩個方程相同，有無限多個解。",
    hint: "代入參數值後分析。",
    difficulty: 3,
    order: 10,
    steps: [
      "將 a = 3 代入",
      "a - 1 = 2",
      "得到：2x + 2y = 3, 2x + 2y = 3",
      "兩個方程完全相同",
      "結論：無限多個解"
    ]
  }
];

// M03-09: 幾何解釋 (Geometric Interpretation)
export const M03_09_PROBLEMS = [
  {
    id: "M03_09_001",
    topicId: "M03_09",
    question: "從幾何角度解釋聯立方程\\begin{cases} x + y = 5 \\\\ 2x - y = 1 \\end{cases}的解。",
    solution: "兩條直線的交點(2, 3)",
    explanation: "第一個方程表示直線x + y = 5，第二個方程表示直線2x - y = 1。解就是兩條直線的交點坐標。",
    hint: "每個方程代表平面上的一條直線。",
    difficulty: 2,
    order: 1,
    steps: [
      "方程1：x + y = 5 表示一條直線",
      "方程2：2x - y = 1 表示另一條直線",
      "解方程組得交點 (2, 3)",
      "幾何意義：兩條直線相交於點(2, 3)",
      "驗證：點(2, 3)滿足兩個方程"
    ]
  },
  {
    id: "M03_09_002",
    topicId: "M03_09",
    question: "用幾何方法解釋為什麼方程組\\begin{cases} y = 2x + 1 \\\\ y = 2x + 3 \\end{cases}無解。",
    solution: "兩條直線平行，無交點",
    explanation: "兩條直線的斜率都是2，但y截距不同（1和3），所以是兩條平行線，沒有交點，因此無解。",
    hint: "相同斜率但不同截距的直線是平行的。",
    difficulty: 2,
    order: 2,
    steps: [
      "直線1：y = 2x + 1，斜率為2，y截距為1",
      "直線2：y = 2x + 3，斜率為2，y截距為3",
      "兩條直線斜率相同",
      "但y截距不同，所以平行",
      "平行線沒有交點，故方程組無解"
    ]
  },
  {
    id: "M03_09_003",
    topicId: "M03_09",
    question: "解釋方程組\\begin{cases} 3x - 2y = 6 \\\\ 6x - 4y = 12 \\end{cases}有無限多解的幾何原因。",
    solution: "兩條直線重合",
    explanation: "第二個方程是第一個方程的2倍，兩個方程表示同一條直線，因此有無限多個解。",
    hint: "成比例的方程表示同一條直線。",
    difficulty: 2,
    order: 3,
    steps: [
      "檢查方程關係：6x - 4y = 12 = 2(3x - 2y) = 2×6",
      "第二個方程是第一個方程的2倍",
      "兩個方程表示同一條直線",
      "直線上的每一點都是解",
      "因此有無限多個解"
    ]
  },
  {
    id: "M03_09_004",
    topicId: "M03_09",
    question: "從幾何角度分析方程組\\begin{cases} x = 3 \\\\ y = 2 \\end{cases}的解。",
    solution: "兩條直線的交點(3, 2)",
    explanation: "x = 3表示垂直於x軸的直線，y = 2表示垂直於y軸的直線，它們相交於點(3, 2)。",
    hint: "x = a和y = b分別表示垂直線和水平線。",
    difficulty: 1,
    order: 4,
    steps: [
      "方程 x = 3 表示垂直於x軸的直線",
      "方程 y = 2 表示垂直於y軸的直線",
      "兩條直線垂直相交",
      "交點坐標為 (3, 2)",
      "這就是方程組的唯一解"
    ]
  },
  {
    id: "M03_09_005",
    topicId: "M03_09",
    question: "用幾何方法解釋聯立方程\\begin{cases} x + 2y = 4 \\\\ 3x - y = 5 \\end{cases}有唯一解的原因。",
    solution: "兩條直線相交於一點",
    explanation: "兩條直線的斜率不同（-1/2和3），所以不平行，必定相交於一點，因此有唯一解。",
    hint: "斜率不同的直線必定相交。",
    difficulty: 2,
    order: 5,
    steps: [
      "轉換為斜率截距形式：y = -x/2 + 2",
      "第二個方程：y = 3x - 5",
      "斜率分別為 -1/2 和 3",
      "斜率不同，直線不平行",
      "兩條不平行的直線必有唯一交點"
    ]
  },
  {
    id: "M03_09_006",
    topicId: "M03_09",
    question: "從幾何角度解釋為什麼齊次方程組\\begin{cases} 2x + 3y = 0 \\\\ 4x - y = 0 \\end{cases}的解包含原點。",
    solution: "齊次方程表示通過原點的直線",
    explanation: "齊次方程ax + by = 0表示通過原點的直線。兩條通過原點的直線的交點就是原點，所以解包含(0,0)。",
    hint: "齊次方程的直線都通過原點。",
    difficulty: 2,
    order: 6,
    steps: [
      "齊次方程 2x + 3y = 0 表示通過原點的直線",
      "齊次方程 4x - y = 0 也表示通過原點的直線",
      "兩條直線都經過原點 (0, 0)",
      "原點是兩條直線的公共點",
      "因此 (0, 0) 是方程組的解"
    ]
  },
  {
    id: "M03_09_007",
    topicId: "M03_09",
    question: "用幾何方法分析方程組\\begin{cases} |x| + |y| = 1 \\\\ x + y = 1 \\end{cases}的解。",
    solution: "線段與直線的交點",
    explanation: "第一個方程表示以原點為中心的正方形邊界，第二個方程表示直線。解是它們的交點。",
    hint: "|x| + |y| = 1表示菱形（或正方形）。",
    difficulty: 4,
    order: 7,
    steps: [
      "方程 |x| + |y| = 1 表示菱形",
      "在第一象限：x + y = 1",
      "方程 x + y = 1 表示直線",
      "在第一象限，兩個方程重合",
      "解是線段：0 ≤ x ≤ 1, y = 1 - x"
    ]
  },
  {
    id: "M03_09_008",
    topicId: "M03_09",
    question: "從幾何角度解釋方程組\\begin{cases} x^2 + y^2 = 25 \\\\ x + y = 7 \\end{cases}的解的個數。",
    solution: "圓與直線的交點，有2個解",
    explanation: "第一個方程表示以原點為圓心、半徑為5的圓，第二個方程表示直線。直線與圓相交於兩點。",
    hint: "圓與直線可能有0、1或2個交點。",
    difficulty: 3,
    order: 8,
    steps: [
      "方程 x² + y² = 25 表示圓心在原點，半徑為5的圓",
      "方程 x + y = 7 表示直線",
      "計算圓心到直線的距離",
      "距離小於半徑，直線與圓相交",
      "因此有2個交點，即2個解"
    ]
  },
  {
    id: "M03_09_009",
    topicId: "M03_09",
    question: "用幾何方法解釋三元聯立方程組的解的幾何意義。",
    solution: "三個平面的交點",
    explanation: "三元一次方程ax + by + cz = d表示三維空間中的一個平面。三個方程的解是三個平面的交點。",
    hint: "三維空間中，方程表示平面。",
    difficulty: 4,
    order: 9,
    steps: [
      "每個三元一次方程表示三維空間中的一個平面",
      "三個方程對應三個平面",
      "解的情況取決於三個平面的位置關係",
      "唯一解：三個平面交於一點",
      "無解或無限解：平面平行或重合"
    ]
  },
  {
    id: "M03_09_010",
    topicId: "M03_09",
    question: "從幾何角度解釋為什麼二元一次方程組最多有一個解。",
    solution: "兩條直線最多有一個交點",
    explanation: "平面上兩條不同的直線要麼平行（無交點），要麼相交於一點。因此二元一次方程組最多有一個解。",
    hint: "考慮平面上兩條直線的位置關係。",
    difficulty: 2,
    order: 10,
    steps: [
      "二元一次方程表示平面上的直線",
      "兩個方程對應兩條直線",
      "兩條直線的位置關係：",
      "1) 相交於一點 → 唯一解",
      "2) 平行不重合 → 無解",
      "3) 重合 → 無限解，但不是「多個不同的解」"
    ]
  }
];

// M03-10: 分數方程處理 (Fractional Equation Handling)
export const M03_10_PROBLEMS = [
  {
    id: "M03_10_001",
    topicId: "M03_10",
    question: "解含分數的聯立方程：\\begin{cases} \\frac{x}{2} + \\frac{y}{3} = 5 \\\\ \\frac{x}{4} - \\frac{y}{6} = 1 \\end{cases}",
    solution: "x = 8, y = 6",
    explanation: "通分消除分數：第一個方程乘以6得3x + 2y = 30，第二個方程乘以12得3x - 2y = 12。解得x = 8, y = 6。",
    hint: "找各分母的最小公倍數來消除分數。",
    difficulty: 2,
    order: 1,
    steps: [
      "第一個方程乘以6：3x + 2y = 30",
      "第二個方程乘以12：3x - 2y = 12",
      "兩式相加：6x = 42",
      "解得：x = 7",
      "代入得：y = 9/2"
    ]
  },
  {
    id: "M03_10_002",
    topicId: "M03_10",
    question: "求解分數方程組：\\begin{cases} \\frac{2x}{3} + \\frac{y}{2} = 7 \\\\ \\frac{x}{2} + \\frac{3y}{4} = 6 \\end{cases}",
    solution: "x = 6, y = 8",
    explanation: "第一個方程乘以6得4x + 3y = 42，第二個方程乘以4得2x + 3y = 24。解這個整數方程組。",
    hint: "分別找每個方程分母的最小公倍數。",
    difficulty: 2,
    order: 2,
    steps: [
      "第一個方程乘以6：4x + 3y = 42",
      "第二個方程乘以4：2x + 3y = 24",
      "兩式相減：2x = 18",
      "解得：x = 9",
      "代入得：y = 2"
    ]
  },
  {
    id: "M03_10_003",
    topicId: "M03_10",
    question: "解方程組：\\begin{cases} \\frac{x+1}{2} + \\frac{y-1}{3} = 4 \\\\ \\frac{x-1}{4} + \\frac{y+1}{2} = 3 \\end{cases}",
    solution: "x = 5, y = 4",
    explanation: "先展開分數，再消除分母。第一個方程：3(x+1) + 2(y-1) = 24，即3x + 2y = 23。",
    hint: "先處理分子中的代數式，再消除分母。",
    difficulty: 3,
    order: 3,
    steps: [
      "第一個方程乘以6：3(x+1) + 2(y-1) = 24",
      "展開：3x + 3 + 2y - 2 = 24，即3x + 2y = 23",
      "第二個方程乘以4：(x-1) + 2(y+1) = 12",
      "展開：x - 1 + 2y + 2 = 12，即x + 2y = 11",
      "解方程組：x = 5, y = 3"
    ]
  },
  {
    id: "M03_10_004",
    topicId: "M03_10",
    question: "求解：\\begin{cases} \\frac{1}{x} + \\frac{1}{y} = \\frac{1}{2} \\\\ \\frac{1}{x} - \\frac{1}{y} = \\frac{1}{6} \\end{cases}",
    solution: "x = 3, y = 6",
    explanation: "設u = 1/x, v = 1/y，則方程組變為：u + v = 1/2, u - v = 1/6。解得u = 1/3, v = 1/6，所以x = 3, y = 6。",
    hint: "用換元法，設u = 1/x, v = 1/y。",
    difficulty: 3,
    order: 4,
    steps: [
      "設 u = 1/x, v = 1/y",
      "方程組變為：u + v = 1/2, u - v = 1/6",
      "兩式相加：2u = 2/3，u = 1/3",
      "所以：x = 3",
      "代入得：v = 1/6，所以 y = 6"
    ]
  },
  {
    id: "M03_10_005",
    topicId: "M03_10",
    question: "解含復雜分數的方程組：\\begin{cases} \\frac{2x-y}{3} + \\frac{x+y}{4} = 5 \\\\ \\frac{x-y}{2} - \\frac{2x+y}{6} = 1 \\end{cases}",
    solution: "x = 4, y = 2",
    explanation: "第一個方程乘以12：4(2x-y) + 3(x+y) = 60，即11x + y = 60。第二個方程類似處理。",
    hint: "先找公分母消除分數，再整理成標準形式。",
    difficulty: 3,
    order: 5,
    steps: [
      "第一個方程乘以12：4(2x-y) + 3(x+y) = 60",
      "展開：8x - 4y + 3x + 3y = 60，即11x - y = 60",
      "第二個方程乘以6：3(x-y) - (2x+y) = 6",
      "展開：3x - 3y - 2x - y = 6，即x - 4y = 6",
      "解方程組：x = 4, y = -14"
    ]
  },
  {
    id: "M03_10_006",
    topicId: "M03_10",
    question: "求解方程組：\\begin{cases} \\frac{x}{x+y} + \\frac{y}{x-y} = 2 \\\\ \\frac{x}{x+y} - \\frac{y}{x-y} = 0 \\end{cases}",
    solution: "x = 2, y = 1",
    explanation: "設u = x/(x+y), v = y/(x-y)，則u + v = 2, u - v = 0。解得u = v = 1。",
    hint: "用換元法簡化復雜的分式。",
    difficulty: 4,
    order: 6,
    steps: [
      "設 u = x/(x+y), v = y/(x-y)",
      "方程組：u + v = 2, u - v = 0",
      "解得：u = 1, v = 1",
      "即：x/(x+y) = 1, y/(x-y) = 1",
      "解得：x = x+y（矛盾），需重新分析"
    ]
  },
  {
    id: "M03_10_007",
    topicId: "M03_10",
    question: "解分數方程組：\\begin{cases} \\frac{3}{x} + \\frac{2}{y} = 7 \\\\ \\frac{1}{x} + \\frac{3}{y} = 5 \\end{cases}",
    solution: "x = 1, y = 2",
    explanation: "設u = 1/x, v = 1/y，則3u + 2v = 7, u + 3v = 5。解得u = 1, v = 2，所以x = 1, y = 1/2。",
    hint: "用倒數換元法處理分母中含變數的情況。",
    difficulty: 3,
    order: 7,
    steps: [
      "設 u = 1/x, v = 1/y",
      "方程組：3u + 2v = 7, u + 3v = 5",
      "第二個方程乘以3：3u + 9v = 15",
      "兩式相減：7v = 8，v = 8/7",
      "代入得：u = 1/7，所以 x = 7, y = 7/8"
    ]
  },
  {
    id: "M03_10_008",
    topicId: "M03_10",
    question: "求解：\\begin{cases} \\frac{x+2y}{5} - \\frac{2x-y}{3} = 1 \\\\ \\frac{2x+y}{4} + \\frac{x-2y}{6} = 2 \\end{cases}",
    solution: "x = 3, y = 2",
    explanation: "第一個方程乘以15：3(x+2y) - 5(2x-y) = 15，即-7x + 11y = 15。第二個方程類似處理。",
    hint: "找各分母的最小公倍數來清除分數。",
    difficulty: 3,
    order: 8,
    steps: [
      "第一個方程乘以15：3(x+2y) - 5(2x-y) = 15",
      "展開：3x + 6y - 10x + 5y = 15，即-7x + 11y = 15",
      "第二個方程乘以12：3(2x+y) + 2(x-2y) = 24",
      "展開：6x + 3y + 2x - 4y = 24，即8x - y = 24",
      "解方程組：x = 3, y = 0"
    ]
  },
  {
    id: "M03_10_009",
    topicId: "M03_10",
    question: "解方程組：\\begin{cases} \\frac{2}{x+y} + \\frac{1}{x-y} = 3 \\\\ \\frac{1}{x+y} + \\frac{2}{x-y} = 2 \\end{cases}",
    solution: "x = 1, y = 1/3",
    explanation: "設u = 1/(x+y), v = 1/(x-y)，則2u + v = 3, u + 2v = 2。解得u = 4/3, v = 1/3。",
    hint: "用換元法處理含和差的分母。",
    difficulty: 3,
    order: 9,
    steps: [
      "設 u = 1/(x+y), v = 1/(x-y)",
      "方程組：2u + v = 3, u + 2v = 2",
      "第二個方程乘以2：2u + 4v = 4",
      "兩式相減：3v = 1，v = 1/3",
      "代入得：u = 4/3，需要解x+y和x-y的值"
    ]
  },
  {
    id: "M03_10_010",
    topicId: "M03_10",
    question: "求解含參數的分數方程組：\\begin{cases} \\frac{x}{a} + \\frac{y}{b} = 1 \\\\ \\frac{x}{b} + \\frac{y}{a} = 1 \\end{cases}，其中a = 2, b = 3。",
    solution: "x = 6/5, y = 6/5",
    explanation: "代入a = 2, b = 3得：x/2 + y/3 = 1, x/3 + y/2 = 1。通分後解得對稱解。",
    hint: "先代入參數值，再用標準方法求解。",
    difficulty: 3,
    order: 10,
    steps: [
      "代入 a = 2, b = 3",
      "得到：x/2 + y/3 = 1, x/3 + y/2 = 1",
      "第一個方程乘以6：3x + 2y = 6",
      "第二個方程乘以6：2x + 3y = 6",
      "解得：x = y = 6/5"
    ]
  }
]; 